<template>
  <div class="remote-select">
    <el-select
      v-model="selectInput"
      filterable
      remote
      :placeholder="placeholder"
      :remote-method="remoteMethod"
      :loading="loading"
      :clearable="clearable"
      :disabled="disabled"
      :allow-create="allowCreate"
      :default-first-option="allowCreate"
      @change="handleChange"
      @clear="handleClearValue"
      @visible-change="toggleUpperShow"
    >
      <slot></slot>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    }, // v-model的值
    remoteMethod: Function, // 远程搜索的方法
    loading: Boolean,
    clearable: Boolean, // 是否可以删除
    allowCreate: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {};
  },
  computed: {
    selectInput: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    handleClearValue() {
      this.$emit('clear');
    },
    toggleUpperShow(val) {
      this.$emit('visibleChange', val);
    },
    handleChange(val) {
      this.$emit('change', val);
      // console.log(val, '=====');
      this.$nextTick(() => {
        console.log('forceUpdate');
        this.$forceUpdate();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.remote-select {
  /deep/.el-select {
    width: 100% !important;
  }
  /deep/.el-input--suffix {
    .el-input__inner {
      width: 100% !important;
      padding: 4px 7px;
      height: 32px;
      line-height: 1.5;
    }
  }
  /deep/.el-input__suffix {
    top: 5px;
    .el-input__suffix-inner {
      .el-icon-circle-close:before {
        content: '\e79d' !important;
        color: #515a6e;
        opacity: 0.6;
        vertical-align: middle;
      }
    }
  }
}
</style>
